import {
  gql 
} from "@apollo/client";

export const ADD_WHOLESALE_PROGRAM = gql`
    mutation addWholesaleProgram(
        $email: String!
        $firstname: String!
        $lastname: String!
        $phone: String!
        $storelocation: String!
        $website: String!
        $businesstype: String!
        $interested: String!
        $howknow: String!
        $remark: String
        $story: String!
    ) {
        addWholesaleProgram(
            input: {
                email: $email
                firstname: $firstname
                lastname: $lastname
                phone: $phone
                storelocation: $storelocation
                website: $website
                businesstype: $businesstype
                interested: $interested
                howknow: $howknow
                remark: $remark
                story: $story
            }
        ) {
            code
            message
            content
        }
    }
`;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  addWholeSaleMutation: ADD_WHOLESALE_PROGRAM
};
